






































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListShukaArea from '@/components/common/search/ListShukaArea.vue';
import { API_SEARCH_SHUKA_AREA } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlShukaArea',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListShukaArea,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '集荷エリア',
    },
    widthCd: {
      type: Number,
      default: 99, //32,
    },
    widthName: {
      type: Number,
      default: 170,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_SHUKA_AREA,
    listShukaAreaShow: false,
    shukaAreaCd: 0,
    shukaAreaMei: '',
    shukaAreaComment: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { shukaAreaCd, shukaAreaMei, shukaAreaComment } = item;
      this.shukaAreaCd = shukaAreaCd;
      this.shukaAreaMei = shukaAreaMei;
      this.shukaAreaComment = shukaAreaComment;
      this.listShukaAreaShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listShukaAreaShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.shukaAreaCd = value;
      if (value) {
        this.getShukaAreaItem();
      } else {
        this.shukaAreaMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ shukaAreaCd: this.shukaAreaCd });
      }
    },
    getShukaAreaItem() {
      axios
        .get(API_SEARCH_SHUKA_AREA, {
          params: {
            shukaAreaCd: this.shukaAreaCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.shukaAreaMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ shukaAreaCd: this.shukaAreaCd });
            return;
          }
          this.errors = clearNoDataError();
          const { shukaAreaMei } = res.data.responseData[0];
          this.shukaAreaMei = shukaAreaMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [shukaAreaCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.shukaAreaCd': {
      handler(newValue) {
        if (+newValue === +this.shukaAreaCd) return;
        this.shukaAreaCd = +newValue;
        if (newValue) {
          this.getShukaAreaItem();
        } else {
          this.shukaAreaMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.shukaAreaCd) {
      this.shukaAreaCd = +this.$attrs.shukaAreaCd;
    }
  },
});
